<template>
    <button type="button" v-bind:class="[locationClass, { open: open }]">
        <div v-if="location.slug_en === 'covered-box'" class="best">
            {{ trans["best-frisas"] }}
        </div>
        <div
            v-if="location.slug_en === 'camarote-maravilha'"
            class="all-inclusive"
        >
            {{ trans["all-inclusive"] }}
        </div>
        <div class="title-ticket">
            {{ location.name }}
        </div>
        <span
            class="ticket-type"
            @mouseover="positionTooltip"
            :class="{
                digital: location.is_digital,
                physical: !location.is_digital
            }"
        >
            {{
                location.is_digital
                    ? trans["initial-digital"]
                    : trans["initial-physical"]
            }}

            <div class="tooltip">
                <h5>
                    {{
                        location.is_digital
                            ? trans["is-digital"]
                            : trans["is-physical"]
                    }}
                </h5>
                <p>
                    {{
                        location.is_digital
                            ? trans["is-digital-information"]
                            : trans["is-physical-information"]
                    }}
                </p>
            </div>
        </span>
    </button>
</template>

<style lang="scss" scoped>
@import "../../../sass/variables";

button {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 58px;
    font-weight: bold;
    text-align: center;
    border: 1px solid var(--color-gray-light);
    border-bottom: 0;
    background: #fff;
    border-radius: 10px 10px 0 0;
    line-height: 18px;
    font-size: 16px;
    color: var(--color-gray-medium-content);
    padding-right: 10px;
    padding-left: 10px;
    flex-direction: column;
    transition: all 0.2s;
    cursor: pointer;
    -webkit-appearance: none;

    &:before {
        content: "";
        display: block;
        position: absolute;
        left: -7px;
        top: -1px;
        border-top: 1px solid var(--color-gray-light);
        background: #fff;
        width: 16px;
        height: 16px;
        z-index: 0;
    }

    &:first-child:before {
        display: none;
    }

    & + button {
        margin-top: 0;
        margin-left: -1px;
    }

    .best {
        position: absolute;
        top: 3px;
        right: 5px;
        font-size: 10px;
        text-transform: uppercase;
        background-color: var(--color-blue-dark);
        color: #fff;
        width: auto;
        border-radius: 1.5em;
        z-index: 0;
        -webkit-transition: all 0.2s;
        transition: all 0.2s;
        height: 1.5em;
        line-height: 1.5em;
        padding: 0px 5px;
    }

    .all-inclusive {
        position: absolute;
        top: 3px;
        right: 5px;
        font-size: 10px;
        text-transform: uppercase;
        background-color: var(--color-camarote-primary, #641467);
        color: #fff;
        width: 75px;
        border-radius: 1.5em;
        z-index: 0;
        transition: all 0.2s;
        height: 1.5em;
        line-height: 1.5em;
    }

    .ticket-type {
        position: absolute;
        left: 0;
        font-size: 10px;
        border: 1px solid;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 10px;
        padding: 2px 7px;
        font-weight: bold;
        top: 0;

        &.digital {
            color: #72c8fa;
        }

        &.physical {
            color: #ef3b22;
        }

        .tooltip {
            position: absolute;
            bottom: 120%;
            width: 300px;
            transform: translateX(-50%);
            background-color: var(--color-gray-light);
            color: var(--color-gray-dark);
            padding: 8px 12px;
            border-radius: 5px;
            font-size: 12px;
            z-index: 1000;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s, visibility 0.3s;
            text-align: left;

            h5 {
                margin: 0;
                font-size: 14px;
                font-weight: bold;
            }

            p {
                margin: 5px 0 0;
                font-size: 12px;
                font-weight: normal;
            }
        }

        &:hover .tooltip {
            opacity: 1;
            visibility: visible;
        }
    }
}

@keyframes fadeInTooltip {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}

.open {
    z-index: 1;

    &:before {
        display: block;
        width: 100%;
        height: 1px;
        bottom: -1px;
        left: 0;
        top: auto;
        background: #fff;
        z-index: 1;
        border: 0;
    }

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        width: 100px;
        height: 3px;
        left: 50%;
        transform: translate(-50%);
    }
}

@media screen and (max-width: 1000px) {
    .title-ticket {
        font-size: 13px;
    }
}

$count: length($tabs-bookers);
@each $section, $color in $tabs-bookers {
    $count: $count - 1;
    button.ticket-tab-#{$section} {
        z-index: #{$count};

        &.open {
            color: $color;

            &:after {
                background: $color;
            }
        }
    }
}
</style>

<script>
export default {
    props: {
        active: {
            type: Object,
            required: true
        },
        location: {
            type: Object,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },

    methods: {
        positionTooltip(event) {
            const tooltip = event.currentTarget.querySelector(".tooltip");
            tooltip.style.marginLeft = "0";

            const distanceToViewport = Math.floor(
                tooltip.getBoundingClientRect().x
            );

            if (distanceToViewport < 0) {
                tooltip.style.marginLeft = `${distanceToViewport * -1}px`;
            }
        }
    },

    computed: {
        open() {
            return this.location.slug_en === this.active.slug_en;
        },
        locationClass() {
            return `ticket-tab-${this.location.slug_en}`;
        }
    }
};
</script>
